var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Itinerary = YouLi.Trip.Itinerary ? YouLi.Trip.Itinerary : {};

(function (YouLi) {
    (function (Trip) {
        (function (Itinerary) {

            var scrollerAdvanceAmount = 120;

            YouLi.Trip.Itinerary.ItineraryItems = null;
            YouLi.Trip.Itinerary.ScheduleItemsOnMap = null;
            YouLi.Trip.Itinerary.ItinerarySelectedDate = "";
            YouLi.Trip.Itinerary.OutstandingResponseItineraryItemId = undefined;

            YouLi.Trip.Itinerary.GoToDate = function (selectedDate) {
                YouLi.Trip.Itinerary.ItinerarySelectedDate = selectedDate;
                YouLi.Trip.Itinerary.FilterItems();
            }

            YouLi.Trip.Itinerary.IdentifyItem = function (itineraryItemId) {
                // $(".panel[data-id='" + itineraryItemId + "']").addClass("highlighted");
                $(".panel[data-id='" + itineraryItemId + "']").fadeTo(500, 0.3, function () {
                    $(".panel[data-id='" + itineraryItemId + "']").fadeTo(500, 1);
                });
                //setTimeout(function () {
                //    $(".panel[data-id='" + itineraryItemId + "']").removeClass("highlighted");
                //}, 2000);
            }

            YouLi.Trip.Itinerary.FilterItems = function () {

                // Update the activated menu
                $("#content-trip-itinerary .trip-dates-menu .nav li").removeClass("active");

                var element = $("#content-trip-itinerary .trip-dates-menu .nav").find("li[data-date='" + YouLi.Trip.Itinerary.ItinerarySelectedDate + "']");
                element.addClass("active");

                // Update the itinerary list
                if (YouLi.Trip.Itinerary.ItinerarySelectedDate == "highlights") {
                    // show only highlighted
                    var itemsToShow = $.grep(YouLi.Trip.Itinerary.ItineraryItems, function (n, i) {
                        return n.HighlightFlag;
                    });

                    var idsToShow = $.map(itemsToShow, function (n, i) {
                        return n.ScheduleItemId;
                    });

                    var elementsToShow = $('.itinerary-accordion .itinerary-accordion-item').filter(function (i, e) {
                        return idsToShow.indexOf($(this).attr('data-id')) > -1
                    });

                    var elementsToHide = $('.itinerary-accordion .itinerary-accordion-item').filter(function (i, e) {
                        return idsToShow.indexOf($(this).attr('data-id')) == -1
                    });

                    $(elementsToShow).show();
                    $(elementsToHide).hide();

                    if (elementsToShow.length == 0) {
                        $(".nothing-scheduled-message").show();
                    } else {
                        $(".nothing-scheduled-message").hide();
                    }

                }
                else if (YouLi.Trip.Itinerary.ItinerarySelectedDate == "all") {
                    $(".nothing-scheduled-message").hide();
                    $('.itinerary-accordion .itinerary-accordion-item').show();
                }
                else {
                    // find the IDs to show and hide
                    var itemsToShow = $.grep(YouLi.Trip.Itinerary.ItineraryItems, function (n, i) {
                        var startDateTime = moment(n.StartDateTime);
                        var endDateTime = moment(n.EndDateTime);
                        var selectedDateMoment = moment(YouLi.Trip.Itinerary.ItinerarySelectedDate);

                        if (n.EndDateTime === null)
                            return startDateTime.isSame(selectedDateMoment, 'date');

                        return selectedDateMoment.isBetween(startDateTime, endDateTime, 'date', '[]');
                    });

                    var idsToShow = $.map(itemsToShow, function (n, i) {
                        return n.ScheduleItemId;
                    });

                    var elementsToShow = $('.itinerary-accordion .itinerary-accordion-item').filter(function (i, e) {
                        return idsToShow.indexOf($(this).attr('data-id')) > -1
                    });

                    var elementsToHide = $('.itinerary-accordion .itinerary-accordion-item').filter(function (i, e) {
                        return idsToShow.indexOf($(this).attr('data-id')) == -1
                    });

                    $(elementsToShow).show();

                    $(elementsToHide).hide();

                    if (elementsToShow.length == 0) {
                        $(".nothing-scheduled-message").show();
                    } else {
                        $(".nothing-scheduled-message").hide();
                    }

                }

                // Show or hide some sections
                $('#content-trip-itinerary #cancelled-items').show();
                $('#content-trip-itinerary #cancelled-items').toggle($('#content-trip-itinerary #list-cancelled').children(':visible').length > 0)
                $('#content-trip-itinerary #no-items').show();
                $('#content-trip-itinerary #no-items').toggle($('#content-trip-itinerary #list-no').children(':visible').length > 0)
            }

            YouLi.Trip.Itinerary.UpdateMenuNav = function () {

                if ($("#content-trip-itinerary .trip-dates-menu").length > 0) {
                    if (YouLi.Trip.CurrentSection == "itinerary") {
                        var scrollerNavLeft = $("#content-trip-itinerary .scroller-nav").position().left;
                        var currentLeft = $("#content-trip-itinerary .trip-dates-menu li").position().left;
                        var lastItem = $("#content-trip-itinerary .trip-dates-menu li:last-child");
                        var lastItemRight = lastItem.position().left + lastItem.outerWidth();

                        var isOffsetFromLeft = currentLeft < 0;
                        var isCutoffOnRight = lastItemRight >= scrollerNavLeft;

                        $("#content-trip-itinerary .scroller-nav .left").toggleClass("disabled", !isOffsetFromLeft);
                        $("#content-trip-itinerary .scroller-nav .right").toggleClass("disabled", !isCutoffOnRight);

                        if (isOffsetFromLeft || isCutoffOnRight) {
                            $("#content-trip-itinerary .scroller-nav").css("visibility", "visible");
                        }
                        else {
                            $("#content-trip-itinerary .scroller-nav").css("visibility", "hidden");
                        }

                        // Fix the max width of itinerary menu
                        $("#content-trip-itinerary .trip-dates-menu").css("max-width", "0px");
                        var containerWidth = $(".content-trip-details-main").width();
                        $("#content-trip-itinerary .trip-dates-menu").css("max-width", containerWidth + "px");
                    }
                }
            }

            YouLi.Trip.Itinerary.DoItemResponse = function (itineraryItemId, responseValue) {

                let targetElement = element;

                // If it's an item that just takes a response, then do that now
                var data = {
                    RequestedFrom: "itinerary",
                    ScheduleItemId: itineraryItemId,
                    InviteeId: $("#InviteeId").val(),
                    ResponseValue: responseValue,
                    ApplyToGang: true
                };

                $.ajax({
                    url: '/trip/inviteeschedulerespond',
                    type: "POST",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(data),
                    complete: function (response) {
                        if (response.responseJSON != undefined && response.responseJSON.url) {
                            YouLi.Common.UI.HideLoading();
                            window.location.href = response.responseJSON.url;
                        }
                        else if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                            YouLi.Common.UI.HideLoading();

                            // reset the multistate check to the previous value
                            $(targetElement).data("multiStateCheck").revert();

                            var errorMessage = "An error occurred.";
                            if (response.responseJSON.errorMessage)
                                errorMessage = response.responseJSON.errorMessage;
                            YouLi.Common.UI.ShowStandardDialog(errorMessage, "Error");
                        }
                        else {
                            // get and restore collapsible panel states 
                            var openPanelIds = $("#itinerary-content .panel-collapse.collapse.in").map(function () { return this.id; }).get();
                            $('#itinerary-content').html(response.responseText);
                            $(".panel-collapse.collapse").removeClass("in");
                            if (openPanelIds.length > 0) {
                                $('#' + openPanelIds.join(',#')).addClass("in"); // do this before calling collapse() as we don't want this animated here
                                $('#' + openPanelIds.join(',#')).collapse("show");
                            }

                            $("#content-trip-itinerary").removeClass("hidden");
                            YouLi.Trip.Itinerary.FilterItems();
                            YouLi.Trip.Itinerary.UpdateMenuNav();

                            YouLi.Trip.UpdateResponseFooter(runOnce = true, checkTripUpdates = false);
                        }
                    }

                });
            }

            YouLi.Trip.Itinerary.AddItineraryItemToCalendar = function (element, calendarType) {
                const itineraryItemElement = $(element).closest(".item-container");
                const itineraryItemId = $(itineraryItemElement).data("id");

                const item = YouLi.Trip.Itinerary.ItineraryItems.find((item) => {
                    return item.ScheduleItemId == itineraryItemId;
                });

                if (item) {
                    const itemDescription = YouLi.Common.Utils.StripHTML(item.Description);
                    const newLineConst = calendarType == "outlook" ? "\\n" : "\n";
                    const eventDescription = `Location: ${item.Location}${newLineConst}${newLineConst}View Details: ${YouLi.Trip.CurrentInviteeMagicLink}${newLineConst}${newLineConst}${itemDescription}`;

                    event = {
                        title: item.Name,
                        start: new Date(item.StartDateTimeUTC + "Z"),
                        end: new Date(item.EndDateTimeUTC + "Z"),
                        address: item.Location,
                        description: eventDescription
                    };

                    YouLi.Trip.AddToCalendar(element, calendarType, event);
                    return false;
                }

                return false;
            };

            $(function () {

                // Itinerary date menu functionality
                $(document).on("click", "#content-trip-itinerary .trip-dates-menu .nav li", function () {

                    YouLi.Trip.Itinerary.GoToDate($(this).data("date"));
                });

                $(document).on("click", "#content-trip-itinerary .scroller-nav .right:not(.disabled)", function () {
                    var lastItem = $("#content-trip-itinerary .trip-dates-menu li:last-child");
                    var lastItemRight = lastItem.position().left + lastItem.outerWidth();
                    var currentLeft = $("#content-trip-itinerary .trip-dates-menu li").position().left;

                    var newLeft = currentLeft;
                    if (lastItemRight >= $("#content-trip-itinerary .scroller-nav").position().left) {
                        newLeft = Math.min(newLeft - scrollerAdvanceAmount, 0);
                        $("#content-trip-itinerary .trip-dates-menu li").css("left", newLeft);
                    }

                    YouLi.Trip.Itinerary.UpdateMenuNav();

                });
                $(document).on("click", "#content-trip-itinerary .scroller-nav .left:not(.disabled)", function () {
                    var currentLeft = $("#content-trip-itinerary .trip-dates-menu li").position().left;
                    var newLeft = currentLeft;
                    if (currentLeft < 0) {
                        newLeft = Math.min(newLeft + scrollerAdvanceAmount, 0);
                        $("#content-trip-itinerary .trip-dates-menu li").css("left", newLeft);
                    }

                    YouLi.Trip.Itinerary.UpdateMenuNav();

                });

                $(window).resize(function () {
                    YouLi.Trip.Itinerary.UpdateMenuNav();
                });

                var currentDisplayedResponse;

                $(document).on('mouseup', "#content-trip-itinerary", function (e) {
                    // hide response popover when click elsewhere
                    if (currentDisplayedResponse && !currentDisplayedResponse.is(e.target) // if the target of the click isn't the container...
                        && currentDisplayedResponse.has(e.target).length === 0) // ... nor a descendant of the container
                    {
                        $(".itinerary-accordion-item .response-popover").css("display", "none");
                    }
                });

                $(document).on("click", "#content-trip-itinerary #expand", function () {

                    if ($(this).hasClass("expanded")) {
                        $(".itinerary-accordion-item .panel-collapse").collapse('hide');
                        // manually add collapsed class as for some reason it's not doing it for me
                        $(".itinerary-accordion-item .panel-heading a[data-toggle='collapse']").addClass('collapsed');
                        $(this).find(".text").text("Expand");
                        $(this).removeClass("expanded");
                    }
                    else {
                        $(".itinerary-accordion-item .panel-collapse").collapse('show');
                        // manually add collapsed class as for some reason it's not doing it for me
                        $(".itinerary-accordion-item .panel-heading a[data-toggle='collapse']").removeClass('collapsed');
                        $(this).find(".text").text("Collapse");
                        $(this).addClass("expanded");
                    }

                });


                // Response functionality
                $(document).on("click", ".itinerary-accordion-item .response:not(.locked):not(.response-not-required) .check", function () {
                    $(".response-popover").css("display", "none"); // hide all others
                    $(this).find(".response-popover").css("display", "block");
                    currentDisplayedResponse = $(this).parent();
                });

                var previewMode = $("#PreviewMode").val() == "True";

                if (!previewMode) {

                    $(document)
                        .off("click", ".itinerary-accordion-item .itinerary-response")
                        .on("click", ".itinerary-accordion-item .itinerary-response", function () {

                        var itineraryItemElement = $(this).closest(".itinerary-accordion-item");
                        var itineraryItemId = $(itineraryItemElement).data("id");
                        var responseValue = $(this).data("response-value");

                        $(".response-popover").css("display", "none"); // hide response popup(s)

                        if (!YouLi.Trip.InviteeHasRespondedYes) {
                            $("#ResponseItineraryItemIncluded").val(itineraryItemId);
                            $("#ResponseItineraryItemIncludedAnswer").val(responseValue);
                            $("#ResponseDialogYesExtraNote").show();
                            $("#ResponseDialogYes").modal('show');
                        }
                        else {
                            YouLi.Trip.Itinerary.DoItemResponse(itineraryItemId, responseValue);
                        }

                    });
                }

                $(document).on("click", "#content-trip-itinerary .invitees-avatars-list", function () {

                    // only allow this if the All Invitees tab is visible to this invitee
                    if (YouLi.Trip.ShowInviteesAllTab) {

                        YouLi.Common.UI.ShowLoading();

                        let itineraryItemElement = $(this).closest(".itinerary-accordion-item");
                        let itineraryItemId = $(itineraryItemElement).data("id");
                        let inviteeId = $("#InviteeId").val();

                        $.ajax({
                            url: `/trip/itineraryparticipants/?id=${itineraryItemId}&inviteeid=${inviteeId}`,
                            type: "GET",
                            dataType: "json",
                            contentType: "application/json; charset=utf-8",
                            complete: function (response) {
                                YouLi.Common.UI.HideLoading();
                                if (response.status === 500 || (response.responseJSON != undefined && response.responseJSON.success == false)) {
                                    YouLi.Common.UI.ShowStandardDialog("An error occurred when loading.");
                                }
                                else {
                                    $("#invitees-dialog-content").html(response.responseText);
                                    $('#invitees-dialog').modal('show');
                                }
                            }
                        });
                    }
                });

                // initially always have everything expanded
                $("#content-trip-itinerary #expand").trigger("click");

                // set up the map with markers
                if (YouLi.Trip.Maps && YouLi.Trip.Itinerary.ScheduleItemsOnMap && YouLi.Trip.Itinerary.ScheduleItemsOnMap.length > 0) {
                    YouLi.Trip.Maps.InitialiseItinerary();
                }

            });

        }(YouLi.Trip.Itinerary ? YouLi.Trip.Itinerary : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));
